

export const helperFloat = (el: string) => Number(parseFloat(el).toFixed(2))

export const getQuantityUnit = (quantity: number) => {
  return quantity.toString() + '\u00A0szt.'
}

export const formatPrice = (price: number) => {
  return `${helperFloat(String(price / 100))} zł`
}

export const formatPriceWithoutCurrency = (price: number) => {
  return helperFloat(String(price / 100))
}

export const countJumpCalculation = (
  calculation: 'increment' | 'decrement',
  currentQuantity: number,
  precisionInput: number,
  limit: number
) => {
  if (calculation === 'increment') {
    const overPrecisionInput = currentQuantity % precisionInput

    const newIncrementedTotal =
      currentQuantity + precisionInput - overPrecisionInput

    if (newIncrementedTotal <= limit) {
      return newIncrementedTotal
    } else {
      return limit
    }
  } else {
    const newDecrementedTotal = currentQuantity - precisionInput

    if (newDecrementedTotal <= 0) {
      return 0
    } else {
      return newDecrementedTotal
    }
  }
}

export const multiplyingPriceByQuantityJump = (
  price: string | number,
  quantityJump: number
) => {
  if (typeof price === 'number') {
    return price * quantityJump
  }

  if (typeof price === 'string') {
    if (price === '---') {
      return price
    }

    const priceTemp = price.split('&nbsp;')

    // @sieradz - return string price to number + change , to .
    // + multiplied by quantityJump + toFixed(2)
    return `${(
      parseFloat(
        priceTemp[0].includes(',')
          ? priceTemp[0].replace(',', '.')
          : priceTemp[0]
      ) * quantityJump
    ).toFixed(2)} ${priceTemp[1]}`
  }

  return price
}
